<template>
  <div class="flex flex-col gap-4">
    <div
      v-for="i in 7"
      :key="i"
      class="flex w-full md:w-60 items-center gap-2 rounded-[4px] animate-pulse bg-gray-30 px-[10px] py-[20px] sm:py-[15px]"
    ></div>
  </div>
</template>


<script>
export default {
  name: 'LoaderErrorReport',
};
</script>
